import React, { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { Scopes } from '../../../../../../constants/Enums';
import { selectStyles } from '../Permissions/PermissionGroup.css';
import { Button } from 'reactstrap';
import OfficeSelectModal from '../Permissions/OfficeSelectModal';
import { connect } from 'react-redux';
const guidToName = (offices, guid) => {
  for (const office of offices) {
    if (office.id === guid) {
      return office.shortName;
    }
  }
  return '';
};

const useModalControl = currentScope => {
  // state indicating that the Office Select modal is open or closed
  const [modalIsOpen, setModalIsOpen] = useState(false);
  // state used to detect when the scope changes
  const [prevScope, setPrevScope] = useState(null);
  // state that falls to false once a value is chosen, to avoid surprise showing of modal
  const [initialRender, setInitialRender] = useState(true);
  // if not initial render, and scope changed to "selected offices", show modal
  useEffect(() => {
    if (
      !initialRender &&
      ((prevScope !== Scopes.SELECTED_OFFICES && currentScope === Scopes.SELECTED_OFFICES) ||
          (prevScope !== Scopes.OFFICE_AND_SELECTED_OFFICES && currentScope === Scopes.OFFICE_AND_SELECTED_OFFICES))
    ) {
      setModalIsOpen(true);
    }
    setPrevScope(currentScope);
  }, [prevScope, currentScope, initialRender]);
  return {
    open: modalIsOpen,
    toggleModal: () => setModalIsOpen(!modalIsOpen),
    permitModalOpenings: () => setInitialRender(false)
  };
};

const scopes = [
  {
    id: Scopes.PROFILE,
    label: 'My Data'
  },
  {
    id: Scopes.TEAM,
    label: 'My Team'
  },
  {
    id: Scopes.OFFICE,
    label: 'My Office'
  },
  {
    id: Scopes.SELECTED_OFFICES,
    label: 'Selected Offices'
  },
  {
    id: Scopes.OFFICE_AND_SELECTED_OFFICES,
    label: 'My Office and Selected Offices'
  },
  {
    id: Scopes.ALL_OFFICES,
    label: 'All Offices'
  }
];

const ScopeOptions = ({ exclusions }) =>
  scopes
    .filter(scope => !exclusions.includes(scope.id))
    .map(scope => (
      <option key={scope.id} value={scope.id}>
        {scope.label}
      </option>
    ));

const ScopeSelect = props => {
  const { open, toggleModal, permitModalOpenings } = useModalControl(
    props.value
  );
  const onChange = e => {
    const value = parseInt(e.target.value);
    permitModalOpenings();
    props.onChange(props.id, value);
  };
  if (props.visible) {
    let officeSelect = null;
    if ((props.value === Scopes.SELECTED_OFFICES || props.value === Scopes.OFFICE_AND_SELECTED_OFFICES) && props.offices != null) {
      const officeList = [];
      for (let i = 0; i < Math.min(2, props.currentOffices.length); i++) {
        const guid = props.currentOffices[i];
        officeList.push(
          <p
            style={{
              fontSize: '13px',
              overflow: 'hidden',
              'text-overflow': 'ellipsis',
              height: '1.5em',
              width: '10em',
              margin: '0.2em'
            }}
            key={i}
          >
            {guidToName(props.offices, guid)}
          </p>
        );
      }
      officeSelect = (
        <>
          {officeList}
          <Button
            disabled={props.disabled}
            onClick={toggleModal}
            color="link"
            size="sm"
          >
            {props.currentOffices.length > 2
              ? `+${props.currentOffices.length - 2} more`
              : 'Edit Selected Offices'}
          </Button>
          <OfficeSelectModal
            open={open}
            close={toggleModal}
            currentOffices={props.currentOffices}
            setCurrentOffices={props.setCurrentOffices}
          />
        </>
      );
    }
    return (
      <>
        <select
          id={props.id}
          className="form-control d-inline-block"
          style={selectStyles}
          onChange={onChange}
          disabled={props.disabled}
          value={props.value}
        >
          <ScopeOptions exclusions={props.exclusions} />
        </select>
        {officeSelect}
      </>
    );
  } else {
    return <select className="d-none" />;
  }
};

const mapStateToProps = state => ({
  offices: state.roster.offices
});

ScopeSelect.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  value: PropTypes.number,
  visible: PropTypes.bool.isRequired
};

export default connect(mapStateToProps)(ScopeSelect);
